const editorConfig = [];

export default editorConfig;
